// v642.2: Adventure Hub tab bar.
//
// Floating tab strip rendered above whichever adventure-side panel is
// currently open (Quests / Atlas / Bounties / Daily / Achievements / Guide).
// Eliminates the Daily-Dashboard-launches-other-modals chain by letting
// the player tab between them with one click.
//
// Mirrors CharacterHubTabBar.js — same overlay style, different keys.

import React from 'react';

const TABS = [
  { key: 'quests',       label: 'Quests',       icon: '📖' },
  { key: 'atlas',        label: 'Atlas',        icon: '🧭' },
  { key: 'bounties',     label: 'Bounties',     icon: '📜' },
  { key: 'daily',        label: 'Daily',        icon: '📅' },
  { key: 'achievements', label: 'Trophies',     icon: '🏆' },
  { key: 'guide',        label: 'Guide',        icon: '📘' },
];

const AdventureHubTabBar = ({ activeTab, onSwitch }) => {
  if (!activeTab) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 10,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10001,
        display: 'flex',
        gap: 4,
        padding: 4,
        background: 'rgba(18, 24, 36, 0.92)',
        border: '1px solid rgba(120, 170, 220, 0.55)',
        borderRadius: 22,
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.55)',
        pointerEvents: 'auto',
        flexWrap: 'wrap',
        maxWidth: 'calc(100vw - 24px)',
        justifyContent: 'center',
      }}
      role="tablist"
      aria-label="Adventure hub"
    >
      {TABS.map(t => {
        const active = t.key === activeTab;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={(e) => { e.stopPropagation(); if (!active) onSwitch(t.key); }}
            title={t.label}
            style={{
              padding: '5px 11px',
              border: '1px solid ' + (active ? '#7eb8da' : 'transparent'),
              background: active
                ? 'linear-gradient(180deg, rgba(126, 184, 218, 0.30), rgba(126, 184, 218, 0.10))'
                : 'transparent',
              color: active ? '#dceeff' : '#cfd6e4',
              borderRadius: 18,
              cursor: active ? 'default' : 'pointer',
              fontSize: 12,
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              minWidth: 78,
              justifyContent: 'center',
              transition: 'background 0.15s',
            }}
          >
            <span style={{ fontSize: 13 }}>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default AdventureHubTabBar;
